import { Layout, theme, Typography } from "antd";
import MeetingsTable from "../components/meetings/MeetingsTable";

const { Content } = Layout;

const Meetings = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            GÖRÜŞLƏR
          </Typography.Title>
          <MeetingsTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Meetings;
